import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@uhg-abyss/web/ui/Link';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { event } from '@uhg-abyss/web/tools/event';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import marketingDetailsRoutes from './MarketingDetailsPageRoutes.json';
import { StyledLink } from '@src/common/Link';

const Wrapper = styled('div', {});

const StyledNavLink = styled(Link, {
  display: 'block',
  padding: '0px 12px 0px 12px',
  width: '100%',

  '&:hover': {
    backgroundColor: '#E5F8FB',
  },

  '&.abyss-link-active': {
    color: '#000000 !important',
    borderRight: ({ theme }) => {
      return `3px solid ${theme.colors.primary}`;
    },
    backgroundColor: '#E5F8FB !important',
  },
});

const LinkText = styled('div', {
  display: 'flex',
  padding: '4px 0px 4px 18px',
});

const StyledMethod = styled('span', {
  variants: {
    color: {
      GET: { color: '#007000', fontWeight: 'bold' },
      POST: { color: '#196ecf', fontWeight: 'bold' },
      PUT: { color: '#c40000', fontWeight: 'bold' },
      DELETE: { color: '#c40000', fontWeight: 'bold' },
    },
  },
});

const StyledSummary = styled('div', {
  paddingLeft: 5,
  width: '100%',
});

const NewBadge = styled('span', {
  color: '#ff681f',
  fontWeight: 'bold',
});

const PathSummary = styled('span', {
  paddingRight: '16px',
});

const StyledBackButton = styled(StyledLink, {
  margin: '0px 0px 2px 12px',
  padding: '16px 12px 0px 0px',
});

export const SideNavLinkV3 = ({ service, data, currentTags, ...props }) => {
  const { navigate } = useRouter();
  // const [initialOpen, setInitialOpen] = useState([]);

  useEffect(() => {
    const arr = [];
    data.tagNames?.forEach((item, index) => {
      arr.push(item);
    });
    // setInitialOpen(arr);
  }, [data]);

  const handleClick = () => {
    navigate(marketingDetailsRoutes[service]);
  };

  const fireInteractionEvent = (path) => {
    event('INTERACTION_EVENT', {
      interactionName: path?.product,
      interactionValue: `${path?.method} ${path?.name}`,
      interactionContext: 'left navigation link click',
    });
  };

  return (
    <Wrapper>
      <StyledBackButton
        onClick={handleClick}
        fontWeight="$bold"
        before={<IconSymbol icon="arrow_back" />}
      >
        Back to API Details
      </StyledBackButton>
      {data?.map((item) => {
        return (
          <StyledNavLink
            {...props}
            fontWeight="$light"
            key={item.id}
            href={`/documentation/${service}/${item.id}`}
            variant="custom"
            onClick={() => {
              fireInteractionEvent(item);
            }}
          >
            <LinkText style={{ fontSize: '15px' }}>
              <StyledMethod color={item.method}>{item.method}</StyledMethod>
              <StyledSummary>
                <PathSummary>{item.name}</PathSummary>
                {item?.displaybadge && <NewBadge>New</NewBadge>}
              </StyledSummary>
            </LinkText>
          </StyledNavLink>
        );
      })}
    </Wrapper>
  );
};

SideNavLinkV3.propTypes = {
  service: PropTypes.string.isRequired,
  data: PropTypes.shape({
    paths: PropTypes.shape({}),
    pathsByTag: PropTypes.arrayOf(PropTypes.shape({})),
    tagNames: PropTypes.arrayOf(PropTypes.string),
    info: PropTypes.shape({}),
  }),
  currentTags: PropTypes.arrayOf(PropTypes.string),
};

SideNavLinkV3.defaultProps = {
  data: {},
  currentTags: [],
};
